export const mixColors = (firstColor, secondColor, percentage)=>{
    const first = firstColor.replace('#', '');
    const second = secondColor.replace('#', '');
    // convert a decimal value to hex
    const d2h = (d)=>d.toString(16);
    // convert a hex value to decimal
    const h2d = (h)=>parseInt(h, 16);
    let color = '#';
    for(let i = 0; i <= 5; i += 2){
        // loop through each of the 3 hex pairs—red, green, and blue
        const v1 = h2d(first.slice(i, i + 2)); // extract the current pairs
        const v2 = h2d(second.slice(i, i + 2));
        // combine the current pairs from each source color, according to the specified weight
        let val = d2h(Math.floor(v2 + (v1 - v2) * percentage));
        while(val.length < 2){
            val = `0${val}`;
        }
        color += val; // concatenate val to our new color string
    }
    return color;
};

//# sourceMappingURL=mixColors.js.map